/* eslint-disable complexity */
/* eslint-disable max-lines */
import React, {useState, useEffect, useRef, useCallback} from "react";
import {
    LandscapeModal,
    VideoContainer,
    ArticleContainer,
    GuardianVideo,
    QuickFacts,
    ArticleModal,
    VideoModal,
    LegalFooter
} from "../components";
import {isMobile} from "mobile-device-detect";
import {useStoreState, useStoreActions} from "easy-peasy";
import {getContentForLtm, getBodyCopyForLtm} from "../utils/contentful";
import anime from "animejs";
import {documentToHtmlString} from "@contentful/rich-text-html-renderer";
import renderHTML from "react-render-html";
import {stringifyQueryString} from "../utils/queryParsing";
import {useAddThisShare} from "../utils/useAddThisShare";
import {createResults} from "../utils/results";

// eslint-disable-next-line max-statements
const ResultsPage = () => {
    const heroData        = useStoreState(state => state.results.hero);
    const subheroData     = useStoreState(state => state.results.subhero);
    const preparedContent = useStoreState(state => state.results.preparedContent);
    const bodyCopy        = useStoreState(state => state.resultsCopy);
    const answers         = useStoreState(state => state.answers.current);

    const updateResults     = useStoreActions(actions => actions.results.update);
    const updateContent     = useStoreActions(actions => actions.content.update);
    const updateResultsCopy = useStoreActions(
        actions => actions.resultsCopy.update
    );
    const goto              = useStoreActions(actions => actions.path.goto);
    const setAnimation      = useStoreActions(actions => actions.animation.setCurrent);
    const setAnimationId    = useStoreActions(
        actions => actions.animation.setCurrentId
    );
    const updateAnswers     = useStoreActions(actions => actions.answers.update);
    const setQuestionId     = useStoreActions(
        actions => actions.question.setCurrentId
    );

    const [loading, setLoading]                         = useState(true);
    const [articleData, setArticleData]                 = useState({});
    const [videoData, setVideoData]                     = useState({});
    const [articleModalDisplay, setArticleModalDisplay] = useState(false);
    const [videoModalDisplay, setVideoModalDisplay]     = useState(false);
    const [isLandscape, setIsLandscape]                 = useState(
        Math.abs(window.orientation) === 90
    );
    const shareResultRef                                = useRef(null);
    const [scrollPosition, setScrollPosition]           = useState(0);

    // eslint-disable-next-line
  const getAnswersAsQuery = answers.reduce(
    // eslint-disable-next-line
    (queryObject, a, i) => ((queryObject[`q${i + 1}`] = a), queryObject),
        {}
    );
    const removeQuery = url =>
        url.substring(0, url.indexOf(`?`) === -1 ? url.length : url.indexOf(`?`));

    const startPage  = document.referrer === `` ?
        `${removeQuery(window.location.origin)}` :
        `${removeQuery(document.referrer)}`;
    const resultPage =
    document.referrer === `` ?
        `${removeQuery(window.location.href)}?${stringifyQueryString(
            getAnswersAsQuery,
            `comma`
        )}` :
        `${removeQuery(document.referrer)}?${stringifyQueryString(
            getAnswersAsQuery,
            `comma`
        )}`;

    const onShareClick = (e, analyticsArgument) => {
        if (e.type === `addthis.menu.share`) {
            window.dataLayer.push(`${answers[0]}_${analyticsArgument}`);
        }
    };

    useAddThisShare(shareResultRef, e => onShareClick(e, `ShareResults`));

    const onContentFetched = useCallback(() => {
        const script = document.createElement(`script`);

        script.src   = `//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-56cb866e6517daeb`;
        script.async = true;

        document.body.appendChild(script);

        anime({
            targets  : `.results-main`,
            opacity  : 1,
            duration : 600,
            delay    : 3500,
            easing   : `linear`
        });

        anime({
            targets  : `.tan-blob-container`,
            opacity  : 1,
            duration : 600,
            delay    : 3500,
            easing   : `linear`
        });
    }, []);

    const screenOrientation = e => {
        setIsLandscape(Math.abs(window.orientation) === 90);
    };

    useEffect(() => {
        const fetch = async () => {
            try {
                window.addthis                                   = null;
                document.documentElement.style.background        = `#1F5653`;
                document.body.style.background                   = `#1F5653`;
                document.getElementById(`root`).style.background = `#1F5653`;
                document.querySelector(`.App`).style.background  = `#1F5653`;
                const resultCopyContent                          = await getBodyCopyForLtm(answers[0]);
                const content                                    = await getContentForLtm(answers[0]);

                updateResultsCopy(resultCopyContent);
                updateContent(content);

                updateResults(createResults(answers, content));

                setLoading(false);
                // eslint-disable-next-line
      } catch (e) {
            } finally {
                onContentFetched();
            }
        };
        fetch();

        window.addEventListener(`orientationchange`, screenOrientation);
    }, [
        updateResultsCopy,
        updateContent,
        updateResults,
        answers,
        onContentFetched
    ]);

    const openArticleModal = (data, analyticsArgument) => {
        setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
        window.dataLayer.push(`${answers[0]}_${analyticsArgument}`);
        setArticleData(data);
        setArticleModalDisplay(true);
        document.querySelector(`.results-page`).classList.add(`open-modal`);
    };

    const openVideoModal = (data, analyticsArgument) => {
        setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
        window.dataLayer.push(`${answers[0]}_${analyticsArgument}`);
        setVideoData(data);
        setVideoModalDisplay(true);
        document.querySelector(`.results-page`).classList.add(`open-modal`);
    };

    const closeModals = analyticsArgument => {
        window.dataLayer.push(`${answers[0]}_${analyticsArgument}`);
        document.querySelector(`.results-page`).classList.remove(`open-modal`);
        if (isLandscape) {
            window.scrollTo(0, 0);
        } else {
            window.scrollTo(0, scrollPosition);
        }

        setScrollPosition(0);
        setVideoModalDisplay(false);
        setArticleModalDisplay(false);
    };

    const onGuardianClick = () => {
        window.dataLayer.push(`${answers[0]}_LinkToGLI`);
    };

    const createSubHeroContainers = () => {
        const subheroContainers = [];
        subheroContainers.push(
            subheroData[0].contentType === `article` ? (
                <ArticleContainer
                    key={`subhero-content-1`}
                    openArticleModal={openArticleModal}
                    data={subheroData[0]}
                    display={`vertical`}
                    analyticsArgument={`Carousel1`}
                />
            ) : (
                <VideoContainer
                    key={`subhero-content-1`}
                    openVideoModal={openVideoModal}
                    data={subheroData[0]}
                    display={`vertical`}
                    analyticsArgument={`Carousel1`}
                />
            )
        );

        subheroContainers.push(
            subheroData[1].contentType === `article` ? (
                <ArticleContainer
                    key={`subhero-content-2`}
                    openArticleModal={openArticleModal}
                    data={subheroData[1]}
                    display={`vertical`}
                    analyticsArgument={`Carousel2`}
                />
            ) : (
                <VideoContainer
                    key={`subhero-content-2`}
                    openVideoModal={openVideoModal}
                    data={subheroData[1]}
                    display={`vertical`}
                    analyticsArgument={`Carousel2`}
                />
            )
        );

        subheroContainers.push(
            subheroData[2].contentType === `article` ? (
                <ArticleContainer
                    key={`subhero-content-3`}
                    openArticleModal={openArticleModal}
                    data={subheroData[2]}
                    display={`vertical`}
                    analyticsArgument={`Carousel3`}
                />
            ) : (
                <VideoContainer
                    key={`subhero-content-3`}
                    openVideoModal={openVideoModal}
                    data={subheroData[2]}
                    display={`vertical`}
                    analyticsArgument={`Carousel3`}
                />
            )
        );

        return subheroContainers;
    };

    const startOver = () => {
        window.removeEventListener(`orientationchange`, screenOrientation);
        window.dataLayer.push(`${answers[0]}_BackToQ1`);
        const animationData = {
            path     : `/animations/intro/intro-q1.json`,
            autoplay : true,
            loop     : {
                path : `/animations/intro/intro-q1-loop.json`
            }
        };
        setAnimationId(`/animations/intro/intro-q1.json`);
        setAnimation(animationData);
        setQuestionId(`question-start`);
        updateAnswers([]);
        goto(`/q1`);
    };

    if (loading) {
        return null;
    }

    return (
        <section className="results-page">
            <LandscapeModal display={isLandscape && !videoModalDisplay} />
            <main className="results-main">
                <section className="results-container">
                    <header className="header">
                        <h2 className="title">{bodyCopy.heroTitle}</h2>
                        {renderHTML(documentToHtmlString(bodyCopy.heroDescription))}
                    </header>
                    <div className="hero">
                        {heroData.contentType === `article` ? (
                            <ArticleContainer
                                openArticleModal={openArticleModal}
                                data={heroData}
                                display={`horizontal`}
                                isHero={true}
                                analyticsArgument={`Hero`}
                            />
                        ) : (
                            <VideoContainer
                                openVideoModal={openVideoModal}
                                data={heroData}
                                display={`horizontal`}
                                isHero={true}
                                analyticsArgument={`Hero`}
                            />
                        )}
                    </div>
                    <div className="hero-carousel">{createSubHeroContainers()}</div>
                    <div className="guardian-section">
                        <GuardianVideo
                            openVideoModal={openVideoModal}
                            data={{
                                intro            : bodyCopy.contentSeriesIntro,
                                title            : bodyCopy.contentSeriesTitle,
                                headline         : bodyCopy.contentSeriesHeadline,
                                subheadline      : bodyCopy.contentSeriesSubheadline,
                                body             : bodyCopy.contentSeriesBody,
                                video            : bodyCopy.contentSeriesVideo,
                                image            : bodyCopy.videoThumbnail,
                                imageDescription : bodyCopy.videoThumbnailDescription
                            }}
                            analyticsArgument={`GLISeries`}
                        />
                    </div>
                    <div className="quick-facts-section">
                        <QuickFacts
                            data={preparedContent}
                            copyData={{
                                becauseYouSaid   : bodyCopy.becauseYouSaid,
                                didYouKnow       : bodyCopy.didYouKnow,
                                didYouKnowSource : bodyCopy.didYouKnowSource
                            }}
                            openArticleModal={openArticleModal}
                            openVideoModal={openVideoModal}
                        />
                    </div>
                    <section className="guardian-cta-section">
                        <h2>{bodyCopy.guardianHeadline}</h2>
                        <div
                            style={{
                                width           : 114,
                                height          : 2,
                                backgroundColor : `#C3451D`,
                                margin          : `auto`
                            }}
                        ></div>
                        <div className="btn-holder">
                            <a
                                href={bodyCopy.guardianCTAURL}
                                onClick={onGuardianClick}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                {bodyCopy.guardianCTA}
                            </a>
                            <a
                                href="/#"
                                className="addthis_button_compact"
                                data-addthis-url={startPage}
                                data-addthis-title={`Guardian Life Insurance`}
                            >
                                <span>Share tool</span>
                            </a>
                        </div>
                    </section>
                </section>
                <section className="closing-section">
                    <div className="closing-section-content">
                        <div
                            image={answers[0]}
                            className={`cta-image-container ${answers[0]}-container`}
                        />
                        <div className="cta-container">
                            <h2>{bodyCopy.shareResultsHeadline}</h2>
                            <a
                                href="/#"
                                className="addthis_button_compact addthis_button_green"
                                data-addthis-url={resultPage}
                                data-addthis-title={`Guardian Life Insurance`}
                            >
                                <span>Share your results</span>
                            </a>
                            <button
                                className="start-over-button"
                                onClick={startOver}
                                tabIndex="0"
                                onKeyDown={event => {
                                    if (event.keyCode === 13 || event.keyCode === 32) {
                                        startOver();
                                    }
                                }}
                            >
                                <img
                                    src={`/images/back-arrow.svg`}
                                    alt={`start over and return to question 1`}
                                />
                                <p>Start Over</p>
                            </button>
                        </div>
                    </div>
                </section>
                <LegalFooter />
                <ArticleModal
                    data={articleData}
                    display={articleModalDisplay}
                    closeModal={closeModals}
                />
                <VideoModal
                    mobile={isMobile}
                    data={videoData}
                    display={videoModalDisplay}
                    closeModal={closeModals}
                />
            </main>
            <div className="tan-blob-container">
                {!isMobile && <img src={`/images/bg-tan-blob-desktop.svg`} alt="" />}
                {isMobile && <img src={`/images/bg-tan-blob-mobile.svg`} alt="" />}
            </div>
        </section>
    );
};

export default ResultsPage;
